import { Grid } from "@mui/material";
import ByzMuiMultiSelect, { SelectOption } from "../../mui/ByzMuiMultiSelect";
import { useTranslate } from "src/locales";
import { useEffect, useState } from "react";
import { referenceService } from "src/api/references/referenceService";

interface Props {
  value: SelectOption[];
  onChange: (v: SelectOption[]) => void;
  typeId: number;
  customOptions?: SelectOption[]; // Özel options verilirse API çağrısı yapılmaz
}

export default function StatusFilter({ value, onChange, typeId, customOptions }: Props) {
  const { t } = useTranslate();
  const [options, setOptions] = useState<SelectOption[]>([]);

  const fetchStatuses = async () => {
    try {
      const response = await referenceService.processStatus.GetProcessStatusByType(typeId);
      const data = response.data || [];
      
      const newOptions: SelectOption[] = data.map((status: any) => ({
        label: status.status,
        value: String(status.id),
      }));

      setOptions(newOptions);
    } catch (error) {
      console.error("Status listesi alınamadı:", error);
      setOptions([]);
    }
  };

  useEffect(() => {
    // customOptions verilmişse API çağrısı yapma
    if (customOptions && customOptions.length > 0) {
      setOptions(customOptions);
    } else if (typeId) {
      fetchStatuses();
    }
  }, [typeId, customOptions]);

  return (
    <Grid item xs={12} sm={6} md={2}>
      <ByzMuiMultiSelect
        label={t("diet-requests-refectory.status")}
        options={options}
        value={value}
        onChange={onChange}
        minWidth="100%"
      />
    </Grid>
  );
}
